<template>
  <div class="row" style="margin-bottom: 10px; margin-top: 30px">
    <div class="col-md-12 text-center">
      <HomeVencimento
        ref="homeVencimento"
        :planoAtivo="planoAtivo"
        :planoDias="planoDias"
        :vencimento="vencimento"
        @recarregar="recarregarMeusDados()"
      />

      <div class="row" style="margin-bottom: 50px; display: none">
        <div class="col-md-12 text-center">Mensagem</div>
      </div>

      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-12 col-md-8 text-center">
          <div class="text-center">
            <h2 class="tituloJogos">Possíveis Jogos</h2>
            <h6 style="display: none">
              Transmissão não confirmada, aguardando fonte
            </h6>
          </div>
          <ListEventosHome
            ref="listEventosHome"
            :itens="itens"
            :filtroSituacao="[1]"
            :icone="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import ListEventosHome from "../lists/ListEventosHome4";
import HomeVencimento from "../features/HomeVencimento";

export default {
  name: "HomeProgramacao",
  components: { ListEventosHome, HomeVencimento },
  methods: {
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    async carregarItens() {
      var filtros = "?_limit=600";

      if (this.retornaSite() == "7live") {
        filtros = "?dsaC3d889g9fd=iuiuy78d7g";
      }

      const response = await api.get("/evento" + filtros);
      api.valid(response.data, this.$router);

      var arrEventos = [];

      for (
        var indiceEvento = 0;
        indiceEvento < response.data.itens.length;
        indiceEvento++
      ) {
        var item = response.data.itens[indiceEvento];
        arrEventos.push(item);
      }

      this.itens = arrEventos;

      if (response.data.gmt) {
        this.$refs.listEventosHome.gmt = response.data.gmt;
      }

      this.$refs.listEventosHome.loadGif = false;
    },
    async recarregarMeusDados() {
      const response = await api.get("/usuario/meus-dados");

      this.planoAtivo = response.data.item.planoAtivo;
      this.planoDias = response.data.item.planoDias;
      this.vencimento = util.formatDate(response.data.item.vencimento);

      this.$refs.homeVencimento.carregando = false;
    },
  },
  data: function () {
    return {
      planoAtivo: true,
      planoDias: 10,
      vencimento: "",
      isAdmin: false,
      itens: [],
    };
  },
  async mounted() {
    var componentThis = this;

    this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador";

    componentThis.recarregarMeusDados();
    componentThis.carregarItens();

    setInterval(function () {
      componentThis.carregarItens();
    }, 20000);
  },
};
</script>

<style>
.tituloJogos {
  margin-top: 15px;
}
</style>